<template>
  <div class="space-y-3">
    <div
      v-for="i in count"
      :key="i"
      class="border rounded-xl p-4 flex gap-4 items-start animate-pulse"
    >
      <div class="w-24 h-24 rounded-lg bg-gray-100" />
      <div class="flex-1 min-w-0">
        <div class="h-4 bg-gray-100 rounded w-3/4" />
        <div class="mt-2 h-3 bg-gray-100 rounded w-1/2" />
        <div class="mt-4 flex items-center gap-3">
          <div class="h-8 bg-gray-100 rounded w-28" />
          <div class="ml-auto h-4 bg-gray-100 rounded w-20" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/* Плейсхолдер кошика на час першого резолву наявності. */
withDefaults(defineProps<{ count?: number }>(), { count: 4 });
</script>
